import type { SearchParams } from '@/server/searchParams.ts';
import { URLParameters } from '@/app/common/urlParameters.ts';
import type { TranslationFunction } from '@/app/components/translations/Translation';
import type { ControlProps } from '../../../Form';
import { getMultilistboxValue } from '../utils';
import getListboxContainer from './getListboxContainer';
import FilterContainer from '../FilterContainer';
import type { CommonProps } from './CommonProps';

type GetLeisureField = {
  searchParams: SearchParams;
  t: TranslationFunction;
  commonProps: CommonProps;
};

const getLeisureField = ({ t, searchParams, commonProps }: GetLeisureField): ControlProps => {
  const value = getMultilistboxValue(searchParams[URLParameters.LEISURE], false);
  const { isWaiting } = commonProps;

  return getListboxContainer({
    fieldName: URLParameters.LEISURE,
    containerName: FilterContainer.LeisureContainer,
    containerTitle: t('vacation.oss.filters.leisure.title'),
    options: [
      { value: 'L4', label: t('vacation.oss.filters.leisure.l4'), disabled: isWaiting },
      { value: 'L1', label: t('vacation.oss.filters.leisure.l1'), disabled: isWaiting },
      { value: 'L2', label: t('vacation.oss.filters.leisure.l2'), disabled: isWaiting },
      { value: 'L3', label: t('vacation.oss.filters.leisure.l3'), disabled: isWaiting },
      { value: 'L5', label: t('vacation.oss.filters.leisure.l5'), disabled: isWaiting },
    ],
    value,
    fieldClassName: '',
    hide: searchParams[URLParameters.DESTINATION] !== 'A',
    ...commonProps,
  });
};

export default getLeisureField;
